import styled from 'styled-components';

export const Main = styled.main`
	text-align: center;
	max-width: 100vw;
	min-height: 100vh;
	background: ${props => props.theme.primary};
`;
